<template>
    <b-card class="shadow" no-body>
        <div class="row mx-0 pl-4">
            <div class="col-12 px-0" v-if="showBadge">
                <div class="d-flex justify-content-end">
                    <badge-with-text :text="badgeText" :badge="showBadgeNumber ? '1' : ''"/>
                </div>
            </div>
            <div class="col-12 col-md-8 col-xl-9 py-4 pl-0">
                <div class="d-flex flex-row-reverse flex-sm-row">
                    <webinar-icon :icon="topicIcon"/>
                    <div class="ml-3 flex-grow-1">
                        <h4 class="text-primary">{{title}}</h4>
                        <p>
                            <span v-html="truncateText ? text : textPart1"></span>
                            <span class="text-secondary" v-if="!truncateText" @click="showMore = true">...{{trans('webinars.dashboard.more')}}</span>
                            <span class="text-secondary d-block d-md-none" v-if="truncateText" @click="showMore = false">...{{trans('webinars.dashboard.less')}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 col-xl-3 py-4">
                <div class="row">
                    <div class="col-6 col-md-12 pl-0">
                        <div class="d-flex align-items-center mb-3">
                            <b-icon
                                icon="calendar3"
                                font-scale="1.5"
                                variant="primary"
                                class="mr-3"
                                :class="pastTextClass"
                            />
                            <p class="mb-0" :class="pastTextClass">{{date}}</p>
                        </div>
                    </div>
                    <div class="col-6 col-md-12 pl-0">
                        <div class="d-flex align-items-center mb-3">
                            <b-icon
                                icon="clock"
                                font-scale="1.5"
                                variant="primary"
                                class="mr-3"
                                :class="pastTextClass"
                            />
                            <p class="mb-0" :class="pastTextClass">{{time}}</p>
                        </div>
                    </div>
                    <div class="col-12 pl-0">
                        <div class="mb-3">
                            <div class="d-flex align-items-center justify-content-end justify-content-md-start">
                                <b-button @click="openDetail" class="px-4">
                                    {{accessButtonText}}
                                </b-button>
                                <b-icon
                                    icon="check-circle-fill"
                                    variant="success"
                                    font-scale="1.5"
                                    v-if="isAugmented && master.moduleCompleted"
                                    class="ml-3"
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
    import BadgeWithText from "../../atoms/BadgeWithText";
    import WebinarIcon from "../../molecules/WebinarIcon";

    export default {
        name: "WebinarEventCard",
        components: {BadgeWithText, WebinarIcon},
        props: {
            webinarId: Number,
            title: String,
            text: String,
            date: String,
            time: String,
            master: Object,
            isAugmented: Boolean,
            registered: Boolean,
            isPast: Boolean,
            topicImage: String,
            showBadge: Boolean,
            showBadgeNumber: Boolean,
            accessButtonText: String
        },
        data() {
            return {
                textMiddle: 0,
                showMore: false,
                screenWidth: 0
            }
        },
        mounted() {
            this.splitDescription();
        },
        methods: {
            splitDescription() {
                this.textMiddle = Math.floor(this.text.length / 2);
            },
            handleResize() {
                this.screenWidth = window.innerWidth;
            },
            openDetail(){
                this.$router.push(`/webinar/${this.webinarId}/detail`);
            }
        },
        computed: {
            sessionTimes() {
                return this.sessions.map(session => session.time).join(', ');
            },
            textPart1() {
                return this.text.slice(0, this.textMiddle);
            },
            truncateText(){
                return this.screenWidth > 768 ? true : this.showMore;
            },
            badgeText(){
                return this.isAugmented && this.registered && this.isPast
                    ? this.trans('webinars.dashboard.module_to_complete')
                    : this.trans('webinars.dashboard.augmented_webinar')
            },
            pastTextClass(){
                return this.isPast ? 'text-muted' : '';
            },
            topicIcon(){
                if(this.topicImage){
                    return this.topicImage;
                }else{
                    return this.isPast ? "/images/webinars/default-icon-locked.png" : "/images/webinars/default-icon-unlocked.png"
                }
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        }
    }
</script>

